import React from 'react'
import PropTypes from 'prop-types'

import { useTranslation } from '../../../utils/providers'

function ProductListCount({ className, count = 0 }) {
  const { t } = useTranslation()

  return <p className={className}>{t('NUM_ARTICLES')(count)}</p>
}

ProductListCount.propTypes = {
  className: PropTypes.string,
  count: PropTypes.number,
}

export default ProductListCount
